import { Field } from 'formik';
import { View } from 'react-native';

import { Checkbox, XStack } from '@fhs/ui';

export const CheckboxInputFormik = ({ name, label, component: Component }) => {
  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        return (
          <Checkbox
            onChange={() => {
              form.setFieldValue(name, !field.value);
            }}
            checked={field.value}
            label={label}
            disabled={form.isSubmitting}
            error={meta.touched && meta.error}
          >
            <XStack style={{ gap: 8 }}>
              <View>
                <Checkbox.Pressable>
                  <Checkbox.Indicator />
                </Checkbox.Pressable>
              </View>
              <View style={{ flex: 1 }}>
                <Component error={meta.touched && meta.error} />
              </View>
            </XStack>
          </Checkbox>
        );
      }}
    </Field>
  );
};
